module.exports = __webpack_public_path__ + "static/img/bg-vip2.e89ffe93.png";